export default __webpack_public_path__ + "media/pro/cross-dark-ec4d805a.svg";